module.exports = __webpack_public_path__ + "media/images/emblems/Lohn-Ammannsegg-blason-1d8b54bf7082a66d661a03eee7aa8601.png";